"use client";
import { Gear } from "@layer/icons";
import {
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@layer/ui/components";
import { ThemeToggle } from "@layer/ui/patterns";
import { cn } from "@layer/utils/cn";
import { useTranslations } from "next-intl";
import { THEMES } from "@/lib/constants/themes";
import { LangSelection } from "../lang-selection";

const SettingsDropdown = () => {
	const t = useTranslations("Navigation.userDropdown");

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="outline"
					size="icon"
					className={cn("size-8", "rounded-full")}
				>
					<Gear />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-56">
				<DropdownMenuLabel>{t("language")}</DropdownMenuLabel>
				<div className="flex items-center justify-between px-2 py-2">
					<LangSelection />
				</div>
				<DropdownMenuSeparator />
				<DropdownMenuLabel>{t("theme")}</DropdownMenuLabel>
				<div className="flex items-center justify-between px-2 py-2">
					<ThemeToggle themes={THEMES} />
				</div>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export { SettingsDropdown };
